export const breakpoints = {
    xs: 0,
    sm: 600,
    md: 981,
    lg: 1200,
    xl: 1440,
};
